<template>
  <div class="container">
        <div class="wrap">
            <pageHeader/>
            <pageBack/>
            <video ref="video" autoplay playsinline style="width:100%;height:100%"></video>
            <div class="main">
                <p class="font80">定制服装部件选择</p>
                <div class="parts-div">
                    <div class="part" v-for="(item,index) in dataList" :key="index">
                        <p class="font40">{{item.title}}</p>
                        <div class="parts-box">
                            <ul>
                                <li v-for="(part,pindex) in item.parts" :key="pindex" :class="{on:item.checked==pindex}" @click="select(index,pindex)">
                                    <img :src="part.path" alt="" srcset="">
                                    <p>{{part.title}}</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="start-btn" @click="to_link()">
                <img src="../../assets/index/btn_bg.png" alt="" srcset="">
                <p>
                    <span>计算衣服尺寸</span>
                </p>
            </div>
        </div>
    </div>
</template>
<script>
import { postParts } from '@/api/user';
import { Toast } from 'vant';

export default {
    name:'selectParts',
  data() {
    return {
      listMale:[
        {
            title:'衬衫面料',
            parts:[
                {
                    title:'蓝色(M22180141)',
                    path: require('@/assets/cloth/M22180141.png'),
                },{
                    title:'白色(M22190301)',
                    path:require('@/assets/cloth/M22190301.png'),
                },{
                    title:'白色(M22200089)',
                    path:require('@/assets/cloth/M22200089.png'),
                }
            ],
            name:'mianliao',
            checked:0
        },{
            title:'长短袖',
            parts:[
                {
                    title:'长袖',
                    path: require('@/assets/cloth/长袖.png'),
                }
            ],
            name:'changduan',
            checked:0
        },{
            title:'袖口',
            parts:[
                {
                    title:'弧形/1803',
                    path:require('@/assets/cloth/弧形-1803.png'),
                },{
                    title:'六角/T-65',
                    path:require('@/assets/cloth/六角-T-65.png'),
                },{
                    title:'直角/L-60',
                    path:require('@/assets/cloth/直角-L-60.png'),
                }
            ],
            name:'xiukou',
            checked:0
        },{
            title:'下摆造型',
            parts:[
                {
                    title:'平摆',
                    path: require('@/assets/cloth/平摆.png'),
                },{
                    title:'圆摆',
                    path:require('@/assets/cloth/圆摆.png'),
                }
            ],
            name:'xiabai',
            checked:0
        },{
            title:'领子造型',
            parts:[
                {
                    title:'圆领',
                    path: require('@/assets/cloth/圆领-D506.png'),
                },{
                    title:'立领',
                    path:require('@/assets/cloth/立领-D505.png'),
                }
            ],
            name:'lingzi',
            checked:0
        },{
            title:'门襟',
            parts:[
                {
                    title:'明门襟',
                    path: require('@/assets/cloth/明门襟.png'),
                },{
                    title:'暗门襟',
                    path:require('@/assets/cloth/暗门襟.png'),
                }
            ],
            name:'menjin',
            checked:0
        },{
            title:'胸袋款式',
            parts:[
                {
                    title:'无胸袋',
                    path: require('@/assets/cloth/无胸袋.png'),
                },{
                    title:'圆角胸袋',
                    path:require('@/assets/cloth/圆角.png'),
                },{
                    title:'三角胸袋',
                    path:require('@/assets/cloth/三角.png'),
                }
            ],
            name:'xiongdai',
            checked:0
        }
      ],
      listFemale:[
      {
            title:'衬衫面料',
            parts:[
                {
                    title:'蓝色(M22180141)',
                    path: require('@/assets/cloth/M22180141.png'),
                },{
                    title:'白色(M22190301)',
                    path:require('@/assets/cloth/M22190301.png'),
                }
            ],
            name:'mianliao',
            checked:0
        },{
            title:'长短袖',
            parts:[
                {
                    title:'长袖',
                    path: require('@/assets/cloth/长袖.png'),
                }
            ],
            name:'changduan',
            checked:0
        },{
            title:'袖口',
            parts:[
                {
                    title:'圆角袖口',
                    path:require('@/assets/cloth/圆角袖口.png'),
                },{
                    title:'六角袖口',
                    path:require('@/assets/cloth/六角-T-65.png'),
                }
            ],
            name:'xiukou',
            checked:0
        },{
            title:'下摆造型',
            parts:[{
                    title:'圆摆',
                    path:require('@/assets/cloth/圆摆.png'),
                }
            ],
            name:'xiabai',
            checked:0
        },{
            title:'领子造型',
            parts:[
                {
                    title:'小方领',
                    path: require('@/assets/cloth/小方领.png'),
                },{
                    title:'小圆领',
                    path:require('@/assets/cloth/小圆领.png'),
                }
            ],
            name:'lingzi',
            checked:0
        },{
            title:'门襟',
            parts:[
                {
                    title:'明门襟',
                    path: require('@/assets/cloth/明门襟.png'),
                },{
                    title:'暗门襟',
                    path:require('@/assets/cloth/暗门襟.png'),
                }
            ],
            name:'menjin',
            checked:0
        }
      ],
      video:null,
      stream:null,
      dataList:[],
    }
  },
  methods: {
    select(index,s_index){
        this.dataList[index].checked = s_index
    },
    // 开始摄像头
    startCamera() {
      // environment
      navigator.mediaDevices.getUserMedia({ video:  { facingMode: "user" }, audio: false })
        .then((mediaStream) => {
            this.video = this.$refs.video;
          this.$refs.video.srcObject = mediaStream;
          this.stream = mediaStream; // 保存媒体流对象以便后续停止使用
          this.$refs.video.play(); // 确保视频播放
        })
        .catch((err) => {
          console.error("navigator.getUserMedia error:", err);
        });
    },
    to_link(){
        let data = {}
        let images = [];
        this.dataList.forEach((item,index) => {
            item.parts.forEach((part,pindex) => {
                if(pindex == item.checked ){
                    if(index!=1){
                        data[item.title] = part.title
                    }
                    images.push({
                        path:part.path,
                        title:part.title,
                    })
                }
            })
        })
        postParts({id:localStorage.getItem('taskId'),params:JSON.stringify(data)}).then(res => {
            if(res.code==1){
                localStorage.setItem('custom_parts', JSON.stringify(images))
                this.$router.push('clothSize');
            }else{
                Toast(res.msg);
            }
        })
    },
    stopCamera() {
      if (this.stream) {
        // 停止所有媒体轨道
        this.stream.getTracks().forEach(track => track.stop());
        this.stream = null; // 清空媒体流
      }
      if (this.video) {
        this.video.srcObject = null; // 清空video元素的srcObject
      }
    },
  },
  // 例如这个函数就会在组件挂载完成后被调用
  mounted() {
    let sex = JSON.parse(localStorage.getItem('userInfo')).sex
    let dataList = sex=='女'?this.listFemale:this.listMale
    this.dataList = dataList;
    // 页面加载完成后自动调用摄像头
    // this.startCamera();
  },
  beforeDestroy() {
    // 组件销毁前确保停止摄像头
    // if (this.stream) {
    //   this.stopCamera();
    // }
  }
}
</script>

<style src="./index.less" scoped lang="less"></style>